// DB column to frontend label map

// Reverse the map so that DB column is the key and label is the value
import { Typography } from "@deere/fuel-react";
import { useEffect, useState } from "react";

const Logs = (props) => {
  const { auditDetails, activeStep } = props;

  const [logs, setLogs] = useState([]);

  // Update the isDocumentLog function to be more generic
const isDocumentLog = (log) => {
  const fieldName = (log.fieldName || '').toLowerCase();
  const newValue = (log.newValue || '').toLowerCase();
  
  // Check for generic document-related keywords
  return fieldName.includes('document') || 
         fieldName.includes('doc') ||
         newValue.includes('doc uploaded') ||
         newValue.includes('doc deleted') ||
         newValue.includes('document uploaded') ||
         newValue.includes('document deleted') ||
         // Check for common document operation patterns
         newValue.includes('uploaded') && (fieldName.includes('doc') || fieldName.includes('document')) ||
         newValue.includes('deleted') && (fieldName.includes('doc') || fieldName.includes('document'));
};

  useEffect(() => {
    if ( auditDetails && Array.isArray(auditDetails.data) && auditDetails.data.length > 0 && auditDetails.data[0].orderPathId === activeStep ) {
      setLogs(auditDetails.data);
    } else {
      setLogs([]);
    }
  }, [auditDetails]);
  return (
    <div className="flex flex-col h-[400px] w-[800px] overflow-auto">
      {logs.length === 0 ? (
        <div className="flex flex-1 items-start justify-center h-full w-full text-gray-700 text-lg font-semibold min-h-[400px] pt-[70px]">
          <div className="text-center w-[800px] max-w-md -ml-[100px]">
            <div style={{ fontSize: "2rem", marginBottom: "1rem" }}>🗒️</div>
            <div>No logs available for this milestone.</div>
            <div className="mt-2 text-base font-normal text-gray-500">
              Log changes will appear here when changes are made to this
              milestone.
            </div>
          </div>
        </div>
      ) : (
        logs.map((log, index) => (
          <div key={index} className="mb-2 p-2 border-b border-gray-200 w-[700px]">
            <div className="flex flex-wrap gap-4 items-baseline">
              <Typography
                fontWeight="700"
                fontSize={14}
                className="min-w-[140px]"
              >
                {log.actionTime
                  ? (() => {
                      // Format to yyyy-mm-dd HH:MM:SS
                      const dt = log.actionTime.replace("T", " ").split(".")[0];
                      return dt;
                    })()
                  : ""}
              </Typography>
              <Typography
                fontWeight="400"
                fontSize={14}
                className="min-w-[10px]"
              >
                (User:{log.userId}) :
              </Typography>
              <Typography fontWeight="400" fontSize={14} className="flex-1">
                {isDocumentLog(log) ? (
                  // For document logs, show only the newValue
                  <span className="font-semibold">{log.newValue}</span>
                ) : (
                  // For non-document logs, show the standard format
                  <>
                    <span className="font-semibold">{log.fieldName}</span> changed
                    from{" "}
                    <span className="font-semibold">{log.oldValue ?? "NULL"}</span>{" "}
                    to{" "}
                    <span className="font-semibold">{log.newValue ?? "NULL"}</span>
                  </>
                )}
              </Typography>
            </div>
          </div>
        ))
      )}
    </div>
  );
};

export default Logs;
